module.exports = __webpack_public_path__ + "img/2_156.1c9cd048.png";